import styled from "styled-components";
import { scaleOnClickAnim, whiteBgOnClickAnim } from "../../animations";

const textColor = "#ffb000";
const baseColor = "#db4646";
const subTextColor = "#db4646";
const descriptionBorderColor = "#483b3b";
const errorColor = "#483b3b";

export const Title = styled.div`
  line-height: 1.4;
  margin-bottom: 35px;
  font-size: 20px;
  .nonce {
    height: 30px;
  }
  p,
  textarea {
    font-family: "GT America, regular";
    background: transparent;
    border: none;
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 ${textColor};
    font-size: 18px;
    margin: auto;
    appearance: none;
    cursor: ${(p) => (p.copyCursor ? "auto" : "copy")};
    width: 100%;
    max-width: 500px;
    resize: none;
    user-select: text !important;
    line-height: 1.4;
    font-weight: 300;
    scrollbar-width: none;
    :focus {
      outline-offset: 10px;
      outline: none;
      border: none;
      outline: 0;
    }
    ::selection {
      background: none;
      border: none;
      text-decoration-line: underline;
      :-moz-focus-inner {
        border: none;
        outline: none;
      }
    }
  }
`;
export const Button = styled.div`
  background: ${textColor};
  border: solid 3px ${textColor};
  border-radius: 38px;
  height: 56px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: ${subTextColor};
  text-transform: uppercase;
  font-size: 18px;
  margin: 20px 0;
  position: relative;
  ${(props) =>
    props.clickable
      ? "pointer-events: none; cursor: auto;"
      : "pointer-events: auto; cursor: pointer;"};
  animation: ${(p) => (p.prov ? scaleOnClickAnim : null)};
  animation-duration: 0.333s;
  animation-fill-mode: forwards;
  &&.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.prov ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }
`;

export const SeedInput = styled.input`
  font-family: "GT America, regular";
  background: transparent;
  border: solid 3px;
  border-radius: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffb000;
  outline: none;
  height: 56px;
  font-size: 20px;
  &::placeholder {
    ${(p) => (p.notify ? "color: #483b3b;" : "color: #ffb000;")}
  }
  ${(p) =>
    p.notify
      ? `color: ${errorColor}; border-color: ${errorColor};`
      : `color: ${textColor}; border-color: ${textColor};`}
  ${(p) => (p.clickable ? "pointer-events: none;" : "pointer-events: auto;")};
`;

export const Description = styled.div`
  font-size: 26px;
  margin-bottom: 30px;
  line-height: 1.33;
  h3 {
    text-transform: uppercase;
    margin-bottom: 13px;
  }
  h4 {
    font-size: 20px;
  }
  p {
    font-size: 20px;
    font-family: "GT America, regular";
  }
`;
export const DetailedContainer = styled.div`
  border-radius: 18px;
  border: solid 3px #483b3b;
  width: 315px;

  margin: auto auto 30px;
  @media only screen and (min-width: 375px) {
    width: 315px;
  }
`;
export const DetailedDescription = styled.div`
  padding: 14px 20px;
  h4 {
    font-size: 20px;

    text-transform: uppercase;
    margin-bottom: 10px;
  }
  p {
    font-size: 12px;
  }
`;
export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  text-align: center;
  h4 {
    width: 50%;
    text-align: center;
    padding: 10px;
    border-top: solid 3px ${descriptionBorderColor};
    border-bottom: solid 3px ${descriptionBorderColor};
    text-transform: uppercase;
    :first-child {
      border-right: solid 3px ${descriptionBorderColor};
    }
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  align-items: center;
  min-height: 188px;
  border-bottom: solid 3px ${descriptionBorderColor};
  &&.centered {
    justify-content: center;
  }
  &&.border-b {
    border-bottom: none;
  }
  :first-child {
    border-right: solid 3px ${descriptionBorderColor};
  }
`;
export const Box = styled.div`
  padding: 10px 0;
  border: solid 3px ${textColor};
  margin: 10px auto;
  text-transform: uppercase;
  position: relative;
  width: 120px;
  font-size: 12px;
  &&.round {
    border-radius: 23px;
  }
  svg {
    transform: translateY(1px) translateX(3px);
  }
`;
export const Romb = styled.div`
  padding: 10px 0;
  position: relative;
  border-top: solid 3px ${descriptionBorderColor};
  border-bottom: solid 3px ${descriptionBorderColor};
  margin: 10px auto;
  text-transform: uppercase;
  font-size: 12px;
  width: 90px;
  :after {
    content: "";
    position: absolute;
    border: solid ${textColor};
    border-width: 0 3px 3px 0;
    display: inline-block;
    transform: rotate(315deg);
    top: 2.5px;
    height: 23.8px;
    width: 23.8px;
    right: -13.5px;
  }
  :before {
    content: "";
    position: absolute;
    border: solid ${textColor};
    border-width: 0 3px 3px 0;
    display: inline-block;
    transform: rotate(135deg);
    top: 2.5px;
    height: 23.8px;
    width: 23.8px;
    left: -13.5px;
  }
`;

export const Circle = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  position: absolute;
  background: ${baseColor};
  border: solid 1px ${textColor};
  z-index: 2;
  right: -5px;
  bottom: 50%;
  transform: translateY(50%);
  box-shadow: 0px 0px 0px 2px ${textColor};
  &&.left {
    right: unset;
    left: -5px;
  }
  &&.top {
    bottom: unset;
    top: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &&.bottom {
    bottom: -5px;
    right: 50%;
    transform: translateY(0) translateX(50%);
  }
  &.rightCorner {
    bottom: -5px;
    right: -5px;
    transform: translateY(0);
  }
  &.leftCorner {
    bottom: unset;
    top: -5px;
    left: -5px;
    transform: translateY(0);
  }
`;
export const Line = styled.div`
  height: 3px;
  width: 40px;
  position: absolute;
  z-index: 1;
  background: ${textColor};
  right: -40px;
  bottom: 50%;
  transform: translateY(50%);
  &&.down {
    height: 30px;
    width: 3px;
    right: 50%;
    bottom: -30px;
    transform: translateY(0) translateX(50%);
  }
  &&.diagTop {
    bottom: 50%;
    transform-origin: left;
    width: 80px;
    right: -80px;
    transform: translateY(0) translateX(0) rotate(-57deg);
  }
  &&.diagBot {
    bottom: 50%;
    transform-origin: left;
    width: 80px;
    right: -80px;
    transform: translateY(0) translateX(0) rotate(57deg);
  }
  &&.diagBotLong {
    width: 100px;
    right: -100px;
    transform: translateY(0) translateX(0) rotate(66deg);
    bottom: 0;
    transform-origin: left;
  }
`;
